import { useQuery } from '@tanstack/react-query';
import { GetAllIncidentTypesResponse } from '@EHSNavigator/backend';
import { useApiClients } from '../../client/api/useApiClient';
import CustomIncidentTypes from '../../views/CustomIncidentTypes';
import Loader from '../../components/Loader';

export default function CustomIncidentTypesPage() {
  const { CustomIncidentTypesApi } = useApiClients();
  const { data = [], isLoading } = useQuery<
    GetAllIncidentTypesResponse['incidentTypes']
  >({
    queryKey: ['all-incident-types'],
    queryFn: async () => {
      const response =
        await CustomIncidentTypesApi.customIncidentTypesControllerFindAllIncidentTypes({
          search: '',
        });
      return response?.data.incidentTypes;
    },
  });

  if (isLoading) {
    return <Loader />;
  }

  return <CustomIncidentTypes data={data} />;
}
